
  import { Vue, Component, Prop } from "vue-property-decorator";

  import ModalFullScreen from "@/components/modal/ModalFullScreenNew.vue";
  import CrossIcon from "@/components/icons/CrossIconNew.vue";
  import UIButton from "@/components/button/ui-button.vue";

  @Component({
    components: {
      ModalFullScreen,
      UIButton,
      CrossIcon
    },
  })
  export default class AddEmployeeModal extends Vue {
    @Prop({ type: String, required: true }) readonly title!: string;
    @Prop({ type: Boolean, required: true }) readonly saveDisabled!: boolean;
  }
